import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import RegistrationTab from './hardware/RegistrationTab';
import InstallationTab from './hardware/InstallationTab';
import TestingTab from './hardware/TestingTab';

/**
 * The hardware workshop — the TCU's whole life in three stages:
 *   REGISTRATION   a new TCU enters the database, no machine attached
 *   INSTALLATION   map device → machine with the live commissioning ladder
 *                  and the display-vs-TCU meter cross-check
 *   TESTING        bench / pre-install sessions on the test units or any
 *                  registered device, no mapping needed
 * Tab in ?tab= so each stage is linkable. Registering hands off to Testing
 * ("bench test it") with the fresh device preselected.
 *
 * No page title: the three stage tabs ARE the heading, and the crew works a
 * full screen of live data under them — a title block would only push it down.
 */
const HardwarePage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const TABS = ['registration', 'installation', 'testing'];
    const tabParam = (searchParams.get('tab') || '').toLowerCase();
    const tab = TABS.includes(tabParam) ? tabParam : 'registration';
    const [presetTestDevice, setPresetTestDevice] = useState('');

    const switchTab = (t) => setSearchParams(t === 'registration' ? {} : { tab: t });
    const startTestFor = (deviceId) => {
        setPresetTestDevice(deviceId);
        switchTab('testing');
    };

    return (
        <Box sx={{ px: 3, py: 2, bgcolor: 'background.default', minHeight: '100vh' }}>
            <Tabs value={tab} onChange={(_, v) => switchTab(v)}
                sx={{ mb: 2, minHeight: 44, borderBottom: '1px solid', borderColor: 'divider' }}>
                <Tab value="registration" label="Registration" sx={{ fontWeight: 800, fontSize: 15, textTransform: 'none', minHeight: 44 }} />
                <Tab value="installation" label="Installation" sx={{ fontWeight: 800, fontSize: 15, textTransform: 'none', minHeight: 44 }} />
                <Tab value="testing" label="Testing" sx={{ fontWeight: 800, fontSize: 15, textTransform: 'none', minHeight: 44 }} />
            </Tabs>

            {tab === 'registration' && <RegistrationTab onStartTest={startTestFor} />}
            {tab === 'installation' && <InstallationTab />}
            {tab === 'testing' && <TestingTab presetDevice={presetTestDevice} />}
        </Box>
    );
};

export default HardwarePage;
